module.exports = __webpack_public_path__ + "static/media/update.41488104.svg";